import SERVICES_ACCESS_VK_ADS_API from 'api/services/accesses/vk-ads/v1'
import SERVICES_ACCESS_VK_API from 'api/services/accesses/vk/v1'
import clsx from 'clsx'
import GridSpinner from 'components/UI/GridSpinner'
import { Grid, NetworkIcon, Typography } from 'gu-ui-kit'
import { DoublePanelViewLayout } from 'layouts'
import omit from 'lodash/omit'
import formsSettings from 'modules/Forms/Account/AccessCreate'
import formStyles from 'modules/Forms/common-form.module.scss'
import styles from 'modules/Services/AccountCreate/account-register.module.scss'
import AsideDecoration from 'modules/Services/AsideDecoration'
import React, { useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import useNetworkPalette from 'utils/hooks/useNetworkPalette'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { ROUTES } from 'constants/routes'
import { useParams } from 'react-router'

const API_BY_NETWORK_TYPE = {
  vk: SERVICES_ACCESS_VK_API,
  'vk-ads': SERVICES_ACCESS_VK_ADS_API,
}

const REDIRECT_URL = {
  vk: ROUTES.SERVICES_NETWORK_ACCOUNT_ACCESS,
  'vk-ads': ROUTES.SERVICES_NETWORK_ACCOUNT_ACCESS,
  yd: ROUTES.SERVICES_NETWORK_ACCOUNT,
  'yandex-business': ROUTES.SERVICES_NETWORK_ACCOUNT,
}

const AccessCreate = () => {
  const { networkType, accountId, id } = useParams()
  const pathGen = useGeneratePathI18n()
  const { t } = useTranslation()
  const history = useHistory()
  const [initialValues, setInitialValues] = useState()

  const FormComponent = useMemo(() => formsSettings?.[networkType] || null, [networkType])
  const paletteClass = useNetworkPalette(networkType)

  useEffect(() => {
    if (networkType === 'vk-ads' && !!id) {
      API_BY_NETWORK_TYPE[networkType]
        .fetchAccessById({ networkType, accessId: id })
        .then(({ response, error }) => {
          if (error) {
            throw error
          }

          setInitialValues(omit(response.data, ['id', 'status']))
        })
        .catch(() =>
          history.push(
            pathGen(ROUTES.SERVICES_NETWORK_ACCOUNT_ACCESS, {
              networkType,
              accountId,
            }),
          ),
        )
    }
  }, [id])

  return (
    <>
      <Helmet defer={false}>
        <title>
          {t('common::nav_menu.network_account_register')} {t(`services::networks.${networkType}`)}
        </title>
      </Helmet>

      <DoublePanelViewLayout
        side={
          <AsideDecoration
            icon={
              <Grid
                fluid={false}
                direction={'row'}
                gap={16}
                alignItems={'center'}
              >
                <NetworkIcon
                  dark
                  rounded
                  width={56}
                  name={networkType}
                  type={'unlinked'}
                />
                <Typography
                  component={'div'}
                  variant={'p2'}
                  weight={'medium'}
                  className={styles['palette_' + paletteClass]}
                >
                  {t(`services::networks.${networkType}`)}
                </Typography>
              </Grid>
            }
            backgroundColor={`var(--network-color-${networkType})`}
            className={clsx(
              styles['aside-decoration__container'],
              styles['palette_' + paletteClass],
            )}
          />
        }
        onClose={(e) => {
          e.preventDefault()
          history.push(
            pathGen(REDIRECT_URL[networkType], {
              networkType,
              accountId,
            }),
          )
        }}
      >
        <div className={formStyles['formContainer__inner']}>
          {!!id && !initialValues ? (
            <GridSpinner />
          ) : (
            <FormComponent
              initialValues={initialValues}
              accountId={accountId}
              networkType={networkType}
              accessId={id}
              onClose={() =>
                history.push(
                  pathGen(REDIRECT_URL[networkType], {
                    networkType,
                    accountId,
                  }),
                )
              }
            />
          )}
        </div>
      </DoublePanelViewLayout>
    </>
  )
}

export default AccessCreate
